module.exports = __webpack_public_path__ + "static/media/castro2.ddd6eb99.JPG";